module.exports = __webpack_public_path__ + "img/phone-rotate-landscape.d68cada4.svg";